import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index';
import config from '../../config';

Vue.use(Router)

const _import = require('./_import_' + process.env.NODE_ENV)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/supervise/',
          name: 'list',
          component: _import('studentList/index'),
          meta: { title: '学生列表', icon: 'home', permission: false, noCache: true }
        },
        {
          path: '/supervise/detail',
          name: 'detail',
          component: _import('studentDetail/index'),
          meta: {title: '学生信息', icon: 'detail', permission: false, noCache: true}
        },
        {
          path: '/supervise/wrong',
          name: 'wrong',
          component: _import('wrong/similarityWrong'),
          meta: {title: '共性错题', icon: 'detail', permission: false, noCache: true}
        },
        {
          path: '/supervise/videoHandout',
          name: 'videoHandout',
          component: _import('videoHandout'),
          meta: {title: '知识点详情', icon: 'detail', permission: false, noCache: true}
        },
        {
          path: '/supervise/viewVideo',
          name: 'viewVideo',
          component: _import('studentDetail/history/viewVideo'),
        },
      ]
    },
    {
      path: '/supervise/noPermission',
      name: 'noPermission',
      component: _import('noPermission'),
    },
    {
      path: '*',
      component: _import('404'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js